export const GPU_STATISTICS = {
  avg_ans_token: "Average Token Answer",
  avg_que_token: "Average Question",
  avg_response_time: "Average Response Time",
  max_ans_token: "Max Answer",
  max_que_token: "Max Question",
  max_response_time: "Max Response Time",
};

export const PROJECT_NAME = {
  EVR: "Draft Evidence Report Generator",
  HEALTH_CARE: "Health Care",
  POLICY_NAVIGATOR: "Policy Navigator",
};

export const Language_Models = [
  // {
  //   title: "GPT-4 Turbo Preview (Open AI)",
  //   value: "gpt-4-0125-preview",
  // },
  {
    title: "GPT-4o",
    value: "gpt-4o",
  },
  {
    title: "GPT-o1",
    value: "o1-preview",
  },
  // {
  //   title: "GPT 3.5 Turbo (Open AI)",
  //   value: "gpt-3.5-turbo",
  // },
  // {
  //   title: "Claude 3 Sonnet (Anthropic)",
  //   value: "anthropic.claude-3-sonnet-20240229-v1:0",
  // },
  {
    title: "Claude 3 Haiku (Anthropic)",
    value: "anthropic.claude-3-haiku-20240307-v1:0",
  },
  // {
  //   title: "Claude 3 Opus (Anthropic)",
  //   value: "anthropic.claude-3-opus-20240229-v1:0",
  // },
  {
    title: "Claude 3.5 Sonnet (Anthropic)",
    value: "anthropic.claude-3-5-sonnet-20240620-v1:0",
  },
  // {
  //   title: "Llama 3 8B (Meta)",
  //   value: "meta.llama3-8b-instruct-v1:0",
  // },
  // {
  //   title: "Llama 3 70B (Meta)",
  //   value: "meta.llama3-70b-instruct-v1:0",
  // },
  {
    title: "Meta Llama3.1 8B Instruct v1:0",
    value: "meta.llama3-1-8b-instruct-v1:0",
  },
  {
    title: "Meta Llama3.1 70B Instruct v1:0",
    value: "meta.llama3-1-70b-instruct-v1:0",
  },
  {
    title: "Meta Llama3.1 405B Instruct v1:0",
    value: "meta.llama3-1-405b-instruct-v1:0",
  },
  {
    title: "Meta Llama3.2 90B Instruct v1:0",
    value: "us.meta.llama3-2-90b-instruct-v1:0",
  },
  // {
  //   title: "Llama 3 OpenBioLLM 8B (Meta)",
  //   value: "Llama3-OpenBioLLM-8B",
  // },
  // {
  //   title: "Mistral 7B Instruct",
  //   value: "mistral.mistral-7b-instruct-v0:2",
  // },
  {
    title: "Mixtral 8x7B Instruct",
    value: "mistral.mixtral-8x7b-instruct-v0:1",
  },
  {
    title: "Mistral Large",
    value: "mistral.mistral-large-2402-v1:0",
  },
];